import React from 'react';

import './widget-photos-grid-circle-desktop-basic.scss';

const WidgetPhotosGridCircleDesktopBasic: React.FC<any> = props => (
    <div className="react-multi-carousel-list w-photos-grid-circle-d__list">
        <ul className="react-multi-carousel-track ">
            {
                React.Children.map(props.children, child => (
                    <li className={`react-multi-carousel-item ${props.itemClass}`}>
                        {child}
                    </li>
                ))
            }
        </ul>
    </div>
);

export default WidgetPhotosGridCircleDesktopBasic;
